<template>
  <div>
    <div class="container-fluid">
      <Breadcrumbs main="Рейтинг" title="Сезонный рейтинг BPL"/>
      <b-card>
        <div class="d-flex flex-wrap mb-4 justify-content-between">
          <div>
            <b-select v-model="selectedBplSeason" :options="selectOptions"></b-select>
          </div>
          <div>
            <b-btn @click="getActualizedBpl" :disabled="isLoadingActualization" :variant="isLoadingActualization ? 'primary' : 'info'">
              {{ isLoadingActualization ? 'Идет актуализация...' : 'Актуализировать рейтинг игрока' }}
            </b-btn>
          </div>
        </div>


        <div v-if="isLoadingRatingForBplUsers" class="loading-wrapper">
          <b-spinner class="spinner"></b-spinner>
        </div>
        <div v-else>
          <b-table
              responsive
              show-empty
              stacked="md"
              :striped="true"
              :bordered="true"
              :fields="fields"
                :items="usersRating"
              class="mb-5"
          >
            <template v-slot:cell(place)="{item}">
              {{ item.place }}
            </template>

            <template v-slot:cell(username)="{item}">
              {{ item.username }}
            </template>

            <template v-slot:cell(nickname)="{item}">
              {{ item.nickname || 'не указан' }}
            </template>

            <template v-slot:cell(rating)="{item}">
              <span class="font-weight-bold text-success">{{ item.rating }}</span>
            </template>

            <template v-slot:cell(kill_sum)="{item}">
              {{ item.kill_sum }}
            </template>

            <template v-slot:cell(action)="{item}">
              <div class="align-items-center">
                <router-link :to="{name: 'bpl_season_user_rating_history', params: {id: item.id}, query: {season: selectedBplSeason}}">
                  <b-btn variant="primary" size="sm" class="mr-2">Посмотреть историю</b-btn>
                </router-link>
              </div>
            </template>

            <!-- Если данных нет -->
            <template v-slot:empty>
              <div class="text-center my-4">
                <h6>Нет данных для отображения</h6>
                <p class="text-muted">Попробуйте выбрать другой сезон или обновите данные</p>
              </div>
            </template>
          </b-table>

          <div class="d-flex justify-content-between flex-row-reverse align-items-center">
            <div>
              Показано {{ usersRating.length }} из {{ total }} записей
            </div>
            <b-pagination
                @change="handlePageChange"
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                :disabled="isLoadingRatingForBplUsers"
                class="my-0"
            ></b-pagination>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "BplSeasonalRating",
  data() {
    return {
      selectOptions: [],
      selectedBplSeason: null,
      isLoadingActualization: false,
      isLoadingRatingForBplUsers: false,
      currentPage: 1,
      perPage: 30,
      total: 0,
      usersRating: [],
      fields: [
        {key: 'place', label: 'Место', sortable: true, class: 'text-center'},
        {key: 'username', label: 'Имя пользователя', sortable: true},
        {key: 'nickname', label: 'Никнейм в игре', sortable: true},
        {key: 'rating', label: 'Рейтинг', sortable: true, class: 'text-center'},
        {key: 'kill_sum', label: 'Киллы', sortable: true, class: 'text-center'},
        {key: 'action', label: 'Действия', sortable: false, class: 'text-center'},
      ],
    }
  },
  methods: {
    async getActualizedBpl() {
      try {
        this.isLoadingActualization = true;
        await api.rating.actualizedUsersBplSeasonal();

        // После актуализации перезагружаем текущие данные
        await this.getUsersBplSeasonalRating(this.currentPage);
      } catch (e) {
        console.error('Error actualizing BPL:', e);
      } finally {
        this.isLoadingActualization = false;
      }
    },

    async getUsersBplSeasonalRating(page = 1) {
      if (!this.selectedBplSeason) {
        console.warn('No season selected');
        return;
      }

      try {
        this.isLoadingRatingForBplUsers = true;

        const params = { page: page };

        const response = await api.rating.getUsersBplWithSeasonId(
            this.selectedBplSeason,
            params
        );

        const apiData = response.data || response;

        if (apiData && apiData.message === "Success!" && Array.isArray(apiData.data)) {
          this.$set(this, 'usersRating', [...apiData.data]);
          this.total = apiData.pagination ? apiData.pagination.total : this.usersRating.length;
          this.perPage = apiData.pagination ? apiData.pagination.by : 30;
          this.currentPage = apiData.pagination ? apiData.pagination.page : page;
        } else {
          console.error('Unexpected API response format:', apiData);
          this.usersRating = [];
          this.total = 0;
        }

      } catch (e) {
        console.error('Error loading rating data:', e);
        this.usersRating = [];
        this.total = 0;
      } finally {
        this.isLoadingRatingForBplUsers = false;
      }
    },

    async getBplSeasons() {
      try {
        console.log('Loading BPL seasons...');
        const res = await api.tournament.getBplSeasons();
        console.log('BPL Seasons response:', res);

        const data = res.data || res;
        this.selectOptions = data.data.map(item => ({
          value: item.id,
          text: item.name
        }));

        if (this.selectOptions.length > 0) {
          this.selectedBplSeason = this.selectOptions[0].value;
          console.log('Selected season:', this.selectedBplSeason);
        }
      } catch (e) {
        console.error('Error loading BPL seasons:', e);
      }
    },

    handlePageChange(pageNumber) {
      console.log('Page changed to:', pageNumber, 'from:', this.currentPage);
      this.getUsersBplSeasonalRating(pageNumber);
    }
  },

  mounted() {
    console.log('Component mounted');
    this.getBplSeasons();
  },

  watch: {
    selectedBplSeason(newValue, oldValue) {
      console.log('Season changed from:', oldValue, 'to:', newValue);
      if (newValue) {
        this.currentPage = 1; // Сброс на первую страницу при смене сезона
        this.getUsersBplSeasonalRating(1);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.spinner {
  width: 3rem;
  height: 3rem;
}

.avatar-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #ddd;
}

.badge {
  font-size: 0.875rem;
}

.badge-primary {
  background-color: #007bff;
}

.badge-secondary {
  background-color: #6c757d;
}
</style>